import { DefaultSeo } from 'next-seo';
import { GlobalStyle } from '@styles/global-styles';
import { useRouter } from 'next/router';
import Head from 'next/head';
import { ResponsiveGlobal } from '@styles/responsive';
import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { onDisabledReactDevtoolOnProduction } from '@utils/helper';
import { AppProps, NextWebVitalsMetric } from 'next/app';
import { wrapper } from '../store';

import 'bootstrap/dist/css/bootstrap.min.css';

function MyApp({ Component, ...rest }: AppProps) {
  const router = useRouter();
  const { store, props } = wrapper.useWrappedStore(rest);

  useEffect(() => {
    onDisabledReactDevtoolOnProduction();
  }, []);

  return (
    <>
      <Head>
        <meta
          id="viewport"
          name="viewport"
          content="width=device-width, initial-scale=1"
        />
      </Head>
      <DefaultSeo
        title="Panoee | The Smart Virtual Tour Software for everyone"
        description="Start free to build high-quanlity & smart 360° Virtual Tour in minutes with beautiful themes & unlimited customization."
        openGraph={{
          type: 'website',
          locale: 'en_IE',
          url: router.pathname,
          site_name: 'Panoee',
          title: 'Panoee | The Smart Virtual Tour Software for everyone',
          description:
            'Start free to build high-quanlity & smart 360° Virtual Tour in minutes with beautiful themes & unlimited customization.',
        }}
        additionalMetaTags={[
          {
            property: 'category',
            content: 'Virtual Tour Software',
          },
          {
            property: 'name',
            content: 'Panoee Studio',
          },
          {
            name: 'application-name',
            content: 'Panoee',
          },
        ]}
      />
      <Provider store={store}>
        <Component {...props.pageProps} />
      </Provider>
      <GlobalStyle />
      <ResponsiveGlobal />
    </>
  );
}

export function reportWebVitals({
  id,
  name,
  // startTime,
  value,
  label,
}: NextWebVitalsMetric) {
  if ((window as any).gtag)
    (window as any).gtag('send', 'event', {
      eventCategory:
        label === 'web-vital' ? 'Web Vitals' : 'Next.js custom metric',
      eventAction: name,
      eventValue: Math.round(name === 'CLS' ? value / 1000 : value), // values must be integers
      eventLabel: id, // id unique to current page load
      nonInteraction: true, // avoids affecting bounce rate.
    });
}

export default MyApp;
